import { YoutubeNamedEntry, YoutubeNamedEntryType } from "../../../types/Objects";

/**
 * Map video details into a YoutubeNamedEntry
 * @param videoId
 * @param videoTitle
 * @param videoUrl
 * @returns youtubeNamedEntry
 */
export const videoToNamedEntry = (videoId: string, videoTitle: string, videoUrl: string): YoutubeNamedEntry => {
  return {
    id: videoId,
    name: videoTitle,
    desc: videoUrl,
    value: videoId,
    type: YoutubeNamedEntryType.Video,
    click_action: "edit",
    invalidValueMsg: null,
  };
};

/**
 * Map channel details into a YoutubeNamedEntry
 * @param channelId
 * @param channelName
 * @param channelUrl
 * @returns youtubeNamedEntry
 */
export const channelToNamedEntry = (channelId: string, channelName: string, channelUrl: string): YoutubeNamedEntry => {
  return {
    id: channelId,
    name: channelName,
    desc: channelUrl,
    value: channelId,
    type: YoutubeNamedEntryType.Channel,
    click_action: "edit",
    invalidValueMsg: null,
  };
};

/**
 * Map category details into a YoutubeNamedEntry
 * @param categoryId
 * @param categoryName
 * @returns youtubeNamedEntry
 */
export const categoryToNamedEntry = (categoryId: string, categoryName: string): YoutubeNamedEntry => {
  return {
    id: categoryId,
    name: categoryName,
    desc: categoryName,
    value: categoryName, // Extension is only able to send VG the category name, not the ID, thus we store the name as value
    type: YoutubeNamedEntryType.Category,
    click_action: "edit",
    invalidValueMsg: null,
  };
};

/**
 * Reverse lookup for YoutubeNamedEntryType
 * @param type as number
 * @returns type as string
 */
export function youtubeNamedEntryTypeReverseLookup(type: number): string {
  switch (type) {
    case YoutubeNamedEntryType.Video:
      return "Video";
    case YoutubeNamedEntryType.Channel:
      return "Channel";
    case YoutubeNamedEntryType.Category:
      return "Category";
    default:
      return "Unknown";
  }
}
